import React from 'react';
import {useMedia} from "react-use";
import Card from "./card/Card";
import Carousel, {consts} from "react-elastic-carousel";
import { ConvertTitle } from "./../constants";


const FlipToFibreInterimPlans = (props) => {
    const isMobile = useMedia("(max-width: 992px)");
    const isTablet = useMedia("(min-width: 768px) and (max-width: 991px)");


    const plans = props.plans.map((plan, key) => {

        return (
            <div onClick={event => props.handChangeInterimPlan(plan.id, key, event)}>
                <Card background={"mintGreenLight"}
                      color={"colour-dark-indigo"}
                      title={ConvertTitle(plan.planSpeed)}
                      key={key}
                      plan={plan}
                      monthlyPrice={plan.price}
                      position={key} key={key}
                      active={plan === props.selectedInterimPlan ? "card-active" : ""}
                />
            </div>
        );
    })

    const desktop = <div className="row">
                        {
                            props.plans.map((plan, key) => {
                                return (
                                    <div key={key} className="col-lg-6 col-sm-6" onClick={event => props.handChangeInterimPlan(plan.id, key, event)}>
                                        <Card   background={"mintGreenLight"}
                                                color={"colour-dark-indigo"}
                                                title={ConvertTitle(plan.planSpeed)}
                                                plan={plan}
                                                monthlyPrice={plan.price}
                                                active={plan === props.selectedInterimPlan ? "card-active" : ""}
                                        />
                                    </div>
                                )
                            })
                        }
                    </div>;

    const mobile = <Carousel
                        children={plans}
                        itemsToShow={1}
                        showArrows={false}
                        itemPosition={consts.CENTER}
                        outerSpacing={20}
                        pagination={true}
                    />
    return (
        <div className="interim-plan">
            {isMobile ? !isTablet ? mobile: desktop: desktop}
        </div>
    )
}

export default FlipToFibreInterimPlans;


// WEBPACK FOOTER //
// ./resources/assets/js/flipToFibre/FlipToFibreInterimPlans.js